module.exports = __webpack_public_path__ + "static/media/galerija_2017 (18).53bfa627.jpg";